/** Shared types + Parse row mapping for StudentAvailability (student-facing + instructor profile view). */

export const DAY_ORDER = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

const DAY_LABELS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

export function defaultDays () {
  return DAY_ORDER.map((key, i) => ({
    key,
    label: DAY_LABELS[i],
    start: '',
    end: ''
  }))
}

export function to12hFromMinutes (totalMinutes) {
  if (typeof totalMinutes !== 'number' || Number.isNaN(totalMinutes)) return ''
  const normalized = ((totalMinutes % 1440) + 1440) % 1440
  const h24 = Math.floor(normalized / 60)
  const m = normalized % 60
  const suffix = h24 >= 12 ? 'PM' : 'AM'
  const h12 = h24 % 12 || 12
  return `${h12}:${String(m).padStart(2, '0')} ${suffix}`
}

export function mapAvailabilityRowsToDays (rows) {
  const byDay = {}
  rows.forEach((row) => {
    byDay[row.get('dayKey')] = row
  })
  return defaultDays().map((d) => {
    const row = byDay[d.key]
    if (!row) return { ...d }

    let start =
            row.get('startTime') || to12hFromMinutes(row.get('startMinutes'))
    let end = row.get('endTime') || to12hFromMinutes(row.get('endMinutes'))

    if (!start || start === 'Invalid Date') start = ''
    if (!end || end === 'Invalid Date') end = ''

    return {
      ...d,
      start: start || '',
      end: end || ''
    }
  })
}
